import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { CenteredModal } from '@shared/components/CenteredModal';
import { Text } from '@shared/components/text';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface UploadDocumentModalProps {
  visible: boolean;
  onClose: () => void;
  onSelectCamera: () => void;
  onSelectExternalDevice: () => void;
}

interface UploadOptionProps {
  title: string;
  description: string;
  onPress: () => void;
}

const UploadOption: React.FC<UploadOptionProps> = ({ title, description, onPress }) => (
  <TouchableOpacity
    onPress={onPress}
    activeOpacity={0.7}
    className="flex-row items-center border border-gray-200 rounded-xl p-4"
  >
    <View className="flex-1 mr-3">
      <Text className="text-sm font-bold mb-0.5" style={{ color: colorPalette.primary[700] }}>
        {title}
      </Text>
      <Text className="text-xs text-gray-500">{description}</Text>
    </View>
    <View
      className="w-8 h-8 rounded-full border border-gray-300 justify-center items-center"
    >
      <Icon name="right" size={14} color={colorPalette.gray[500]} />
    </View>
  </TouchableOpacity>
);

export const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
  visible,
  onClose,
  onSelectCamera,
  onSelectExternalDevice,
}) => {
  const { t } = dynamicTranslations();
  const s = 'history.documents.patientSection.uploadModal';

  return (
    <CenteredModal visible={visible} onClose={onClose}>
      <View className="w-full bg-white rounded-2xl pt-5 pb-4 shadow-md">
        <View className="flex-row items-start justify-between px-5 pb-4">
          <Text className="flex-1 text-base font-bold text-gray-900 mr-3 leading-6">
            {t(`${s}.title`)}
          </Text>
          <TouchableOpacity
            onPress={onClose}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Icon name="close" size={18} color={colorPalette.gray[500]} />
          </TouchableOpacity>
        </View>

        <View className="h-px bg-gray-200 mb-3" />

        <View className="px-4 gap-2">
          <UploadOption
            title={t(`${s}.cameraTitle`)}
            description={t(`${s}.cameraDescription`)}
            onPress={onSelectCamera}
          />
          <UploadOption
            title={t(`${s}.externalTitle`)}
            description={t(`${s}.externalDescription`)}
            onPress={onSelectExternalDevice}
          />
        </View>
      </View>
    </CenteredModal>
  );
};
